import React from "react";
import LabelIcon from "Component/Labels/LabelIcon";
import brightness from "Assets/Svg/brightness.svg";
import incometaxdepartment from "Assets/Svg/income-tax-department.svg";
import esic from "Assets/Svg/esic.svg";
import epfo from "Assets/Svg/epfo.svg";
import Button from "@material-ui/core/Button";
import RightArrow from "Assets/Images/rghtarrw.svg";
import piggyBank from "Assets/Svg/piggy-bank-amico.svg";
import { track} from "@amplitude/analytics-browser";

const PayrollComplianceCallOut = () => (
  <div className="payroll-compliance-outer display-flex">
    <div>
      <div
        className="display-flex margin-bottom-24"
        style={{ alignItems: "center" }}
      >
        <img src={brightness} height="16"></img>
        <span className="small-blue t-bold margin-left-8">Breaking news</span>
      </div>

      {window.location.pathname == "/desk" ? (
        <p className="small-dark">
          sumHR now helps you pay & file TDS, PF, ESIC, LWF & PT compliances.
          Get started with these services absolutely free! 💸
        </p>
      ) : (
        <p className="small-dark">
          sumHR now helps you pay & file TDS, PF, ESIC, LWF & PT compliances.{" "}
          <br /> Get started with these services absolutely free! 💸
        </p>
      )}

      <div
        className="display-flex margin-top-24 margin-bottom-24"
        style={{ alignItems: "center" }}
      >
        <div className="display-flex" style={{ alignItems: "center" }}>
          <img src={incometaxdepartment}></img>
          <span
            className="extra-small-dark margin-left-8"
            style={{ color: "#393939", fontSize: 11 }}
          >
            Income <br /> Tax
          </span>
        </div>
        <div
          className="display-flex"
          style={{ alignItems: "center", marginLeft: 40 }}
        >
          <img src={epfo}></img>
          <span
            className="extra-small-dark margin-left-8"
            style={{ color: "#393939", fontSize: 11 }}
          >
            Employees' Provident <br />
            Fund Organisation
          </span>
        </div>
        <div
          className="display-flex"
          style={{ alignItems: "center", marginLeft: 40 }}
        >
          <img src={esic}></img>
          <span
            className="extra-small-dark margin-left-8"
            style={{ color: "#393939", fontSize: 11 }}
          >
            Employees' State <br /> Insurance Corporation
          </span>
        </div>
      </div>

      <a 
        onClick={() => {
          track("mydesk-compliance-experiment-clicked");
       }} 
        href="https://forms.gle/x2WzEQnGQ6ppKcW87" target="_blank">
        <Button
          variant="contained"
          className="btn btn-primary-sm-blue cursor-pointer"
          color="primary"
          endIcon={<img src={RightArrow}></img>}
        >
          Get started
        </Button>
      </a>
    </div>
    {window.location.pathname == "/desk" ? (
      ""
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItem: "center",
          width: "50%",
        }}
      >
        <img src={piggyBank} style={{ height: "100%" }}></img>
      </div>
    )}
  </div>
);

export default PayrollComplianceCallOut;
